(() => {
  const estimate = (area, waste, coverage, price) => {
    if (![area, waste, coverage, price].every(Number.isFinite) || area <= 0 || area > 10000000 || waste < 0 || waste > 100 || coverage <= 0 || price < 0) return null;
    const quantity = Math.max(1, Math.ceil((area * (1 + waste / 100) - 1e-9) / coverage));
    return { quantity, area: quantity * coverage, subtotal: quantity * price / 100 };
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = { estimate };
  if (typeof customElements === 'undefined' || customElements.get('wall-panel-guide')) return;
  class WallPanelGuide extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-guide]').textContent);
      this.prices = JSON.parse(this.querySelector('[data-prices]').textContent);
      this.root = this.closest('.product-form') || this.closest('.shopify-section');
      this.abort = new AbortController();
      this.onChange = () => requestAnimationFrame(() => this.refresh());
      this.root.addEventListener('change', this.onChange, { signal: this.abort.signal });
      this.root.addEventListener('input', this.onChange, { signal: this.abort.signal });
      document.addEventListener('theme:variant:change', this.onChange, { signal: this.abort.signal });
      this.querySelector('[data-apply]')?.addEventListener('click', () => this.apply(), { signal: this.abort.signal });
      this.observer = new MutationObserver(this.onChange);
      const variantInput = this.root.querySelector('[name="id"]');
      if (variantInput) this.observer.observe(variantInput, { attributes: true, attributeFilter: ['value'], childList: true, subtree: true });
      this.refresh();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.ready = false; }
    selected() {
      const raw = this.root.querySelector('select.original-selector')?.value || this.root.querySelector('form[action*="/cart/add"] [name="id"]')?.value || this.dataset.initialVariant;
      return this.data.variants.find(v => String(v.id) === String(raw));
    }
    number(value) { return new Intl.NumberFormat(this.dataset.locale, { maximumFractionDigits: 2 }).format(value); }
    links(selector, items) {
      const list = this.querySelector(selector);
      list.replaceChildren(...items.map(item => {
        const li = document.createElement('li'), a = document.createElement('a'), span = document.createElement('span');
        a.href = item.url;
        if (item.image) { const img = document.createElement('img'); img.src = item.image; img.alt = ''; img.loading = 'lazy'; img.width = 56; img.height = 56; a.append(img); }
        span.textContent = item.title; a.append(span); li.append(a); return li;
      }));
    }
    refresh() {
      const v = this.selected();
      if (!v) { this.querySelector('[data-results]')?.setAttribute('hidden',''); return; }
      const matches = this.data.mode === 'trim' ? this.data.byColour[v.colour] || [] : this.data.matches || [];
      const signature = JSON.stringify([v.colour, matches]);
      if (signature !== this.matchSignature) {
        this.matchSignature = signature;
        this.querySelector('[data-colour]').textContent = v.colour || this.data.colour || '';
        this.querySelector('[data-matches]').hidden = !matches.length;
        this.querySelector('[data-no-match]').hidden = true;
        this.links('[data-match-list]', matches);
        const siblings = this.data.siblings || [];
        this.querySelector('[data-siblings]').hidden = !siblings.length;
        this.links('[data-sibling-list]', siblings);
        this.hidden = !this.querySelector('[data-area]') && !matches.length && !siblings.length;
      }
      const area = this.querySelector('[data-area]');
      if (!area) return;
      this.querySelector('[data-coverage]').textContent = v.coverage ? this.number(v.coverage) : '—';
      this.result = estimate(Number(area.value), Number(this.querySelector('[data-waste]').value), Number(v.coverage), Number(this.prices[v.id]));
      this.querySelector('[data-results]').hidden = !this.result;
      this.querySelector('[data-applied]').hidden = true;
      if (!this.result) return;
      this.querySelector('[data-count]').textContent = this.number(this.result.quantity);
      this.querySelector('[data-total-area]').textContent = this.number(this.result.area);
      this.querySelector('[data-subtotal]').textContent = new Intl.NumberFormat(this.dataset.locale, { style:'currency', currency:this.dataset.currency || 'CAD' }).format(this.result.subtotal);
      this.querySelector('[data-apply]').disabled = !this.quantityInput();
    }
    quantityInput() { return this.root.querySelector('form[action*="/cart/add"] [name="quantity"]') || this.root.querySelector('[name="quantity"]'); }
    apply() {
      this.refresh();
      const quantity = this.quantityInput();
      if (!quantity || !this.result) return;
      quantity.value = this.result.quantity;
      quantity.dispatchEvent(new Event('change', { bubbles:true }));
      requestAnimationFrame(() => { this.querySelector('[data-applied]').hidden = false; });
    }
  }
  customElements.define('wall-panel-guide', WallPanelGuide);
})();
